import type { ProjectContentData } from '../types';
import { PROJECT_CONTENT_TAB_TYPE } from '../types';
import { tableOfContentTab } from './data';

export const primexFinance: ProjectContentData = {
  id: 'primex-finance',
  tabs: [
    {
      id: 'description',
      label: 'Description',
      type: PROJECT_CONTENT_TAB_TYPE.TABLE_OF_CONTENT,
      content: tableOfContentTab,
    },
    {
      id: 'key-metrics',
      label: 'Key Metrics',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'blockchain-network',
          value: 'ETH (Claim on BASE)',
          name: 'Blockchain Network',
          description: (
            <span>
              The blockchain network
              <br />
              where you will claim the
              <br />
              PMX Tokens
            </span>
          ),
        },
        {
          id: 'PMX',
          value: 'PMX',
          name: 'Token Ticker',
          description: (
            <span>
              The symbol representing
              <br />
              the token
            </span>
          ),
        },
        {
          id: 'total-supply',
          value: '1,000,000,000',
          name: 'Total Supply',
          description: (
            <span>
              The total number of <b>PMX</b>
              <br />
              tokens in total supply
            </span>
          ),
        },
        {
          id: 'initial-circulation-supply',
          value: '16.09%',
          name: 'Initial Circulating Supply',
          description: (
            <span>
              The number of <b>PMX</b>
              <br />
              tokens that will be
              <br />
              available at TGE
            </span>
          ),
        },
        {
          id: 'initial-market-cap',
          value: '$6.4M at 40 FDV',
          name: 'Initial Market Cap',
          description: (
            <span>
              The market value of
              <br />
              circulating tokens at TGE
            </span>
          ),
        },
        {
          id: 'token-address',
          value: '0x0B3EAEAd748facDb9d943d3407011f16Eb17D0Cf',
          name: 'Token Address',
          description: (
            <span>
              The contract address of <br />
              the <b>PMX</b> token
            </span>
          ),
        },
      ],
    },
    {
      id: 'deal-terms',
      label: 'Deal Terms',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      content: [
        {
          id: 'total-raising-goal',
          name: 'Total Raising Goal',
          value: '$50,000',
          description: (
            <span>
              The amount aimed to be
              <br />
              raised in the IDO
            </span>
          ),
        },
        {
          id: 'ido-price',
          name: 'IDO Price',
          value: '$0.04',
          description: (
            <span>
              The price per <b>PMX</b> token
              <br />
              during the IDO
            </span>
          ),
        },
        {
          id: 'accepted-payment',
          name: 'Accepted Payment',
          value: 'USDT (BEP20)',
          description: (
            <span>
              The type of crypto
              <br />
              accepted for
              <br />
              participating in the IDO
            </span>
          ),
        },
        {
          id: 'refund-policy',
          name: 'Refund Policy',
          value: '24 hours',
          description: (
            <span>
              The time frame in which you
              <br />
              can request a refund from TGE
            </span>
          ),
        },
      ],
    },
    {
      id: 'vesting',
      label: 'Vesting',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 4,
      content: [
        {
          id: 'tge',
          value: '25%',
          name: 'At TGE',
          description: (
            <span>
              The percentage of tokens
              <br />
              available for claim of
              <br />
              TGE
              <br />
            </span>
          ),
        },
        {
          id: 'vesting',
          value: '3-Months Linear Vesting',
          name: 'Vesting',
          description: <span>3-Months Linear Daily Vesting</span>,
        },
        {
          id: 'magic-launchpad',
          value: 'Magic Launchpad',
          name: 'Distribution Method',
          description: (
            <span>
              The platform handling
              <br />
              the token distribution
              <br />
            </span>
          ),
        },
      ],
    },
    {
      id: 'ido',
      label: 'IDO Schedule',
      type: PROJECT_CONTENT_TAB_TYPE.STAT_LIST,
      layout: 3,
      content: [
        {
          id: 'salestart',
          value: '24/01/2025',
          name: 'Sale Start',
          description: (
            <span>
              The starting date of the
              <br />
              IDO
            </span>
          ),
        },
        {
          id: 'sale-end',
          value: '27/01/2025',
          name: 'Sale End',
          description: (
            <span>
              The closing date of the
              <br />
              IDO
            </span>
          ),
        },
        {
          id: 'tge-date',
          name: 'TGE Date',
          value: '31/01/2025',
          description: (
            <span>
              The <b>PMX</b> token launch
              <br />
              date
            </span>
          ),
        },
        {
          id: 'distribution-start',
          name: 'Token Distribution Start',
          value: '31/01/2025, at 11:00 UTC',
          description: (
            <span>
              The <b>PMX</b> token claim
              <br />
              date
            </span>
          ),
        },
      ],
    },
  ],
};
